import React from 'react';
import styled from 'styled-components';
import { T } from '../../../shared/helpers';
import MdReportProblem from 'src/shared/material_icons/alert/warning.svg';
import { Link } from '../../widgets/buttons';
import { Icon } from '../../widgets/icon';
import { ContainerBase } from '../../widgets/layouts';

const Container = styled(ContainerBase)`
    padding-top: 30px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 160px;
    justify-content: center;

    ${Icon} {
        width: 128px;
        height: 128px;
    }
`;

const NotFoundPage = () => (
    <Container>
        <Icon>
            <MdReportProblem />
        </Icon>
        <h2>{T._('Page not found :(', 'Admin')}</h2>
        <p>
            {T._('Please contact us at:', 'Admin')} <Link href='mailto:help@zakeke.com'>help@zakeke.com</Link>
        </p>
    </Container>
);

export default NotFoundPage;
